var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.06 26.84C29.6837 26.84 31 25.5237 31 23.9C31 22.2763 29.6837 20.96 28.06 20.96C26.4363 20.96 25.12 22.2763 25.12 23.9C25.12 25.5237 26.4363 26.84 28.06 26.84Z",
    fill: "#FFB6BF",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.06 20.96V13.94C28.06 12.8579 27.6302 11.8201 26.8651 11.055C26.0999 10.2898 25.0622 9.86003 23.9801 9.86003C22.898 9.86003 21.8602 10.2898 21.0951 11.055C20.3299 11.8201 19.9 12.8579 19.9 13.94V23.885C19.9 25.4763 19.2679 27.0024 18.1427 28.1277C17.0175 29.2529 15.4913 29.885 13.9 29.885C12.3087 29.885 10.7826 29.2529 9.65738 28.1277C8.53216 27.0024 7.90002 25.4763 7.90002 23.885V19.865",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 3.755C11.9419 3.755 12.9125 4.15594 13.6294 4.87003C14.3463 5.58411 14.751 6.55312 14.755 7.56498V12.53C14.751 14.3534 14.0239 16.1008 12.7331 17.3888C11.4424 18.6767 9.69345 19.4 7.87003 19.4V19.4C6.04799 19.4 4.30052 18.6762 3.01215 17.3879C1.72377 16.0995 1 14.352 1 12.53V7.59501C1 6.58453 1.40142 5.61539 2.11594 4.90088C2.83045 4.18637 3.79949 3.78503 4.80997 3.78503V3.78503",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9299 2V5.615",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80994 2V5.615",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoctor);
export default __webpack_public_path__ + "static/media/ic_doctor.fb507ed86e4a1a4b65dc6051972a76ab.svg";
export { ForwardRef as ReactComponent };